export default __webpack_public_path__ + "static/media/co6.fab92256.png";